// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__23lqW","row":"ProcedureTreatmentSummary_row__Ifpb3"};